module.exports = __webpack_public_path__ + "static/product-l0970-7ddfc271a8b4bd38637c00dcc95d52db.png";